import * as React from 'react';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { FMIcon, FMIconType } from 'atoms';

interface FMIconButtonProps extends IconButtonProps {
    type: FMIconType;
    tooltip?: string;
}

export default (props: FMIconButtonProps) =>
    <Tooltip title={props.tooltip ? props.tooltip : ''} disableFocusListener={true}>
        <IconButton {...props}>
            <FMIcon type={props.type} />
        </IconButton>
    </Tooltip>;
